import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { withRouter } from "tools/routerCompat";
import { Header, Footer } from "components/CoreLayout";
import {MSidebar, ExpiredPasswordModal} from "components/Shared";
import {setCoreLayoutHeaderVisibility, setCoreLayoutSidebarVisibility} from "actions/layout";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class CoreLayout extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // Check URL params for hide flags (set by WindowProvider.openNewWindowWithSSO)
    const urlParams = new URLSearchParams(window.location.search);
    const shouldHideHeader = urlParams.get('hideHeader') === 'true';
    const shouldHideSidebar = urlParams.get('hideSidebar') === 'true';
    
    if (shouldHideHeader) {
      this.props.setCoreLayoutHeaderVisibility(false);
    } else if (!this.props.headerVisible) {
      // Only reset to visible if not explicitly hidden by URL param
      this.props.setCoreLayoutHeaderVisibility(true);
    }
    
    if (shouldHideSidebar) {
      this.props.setCoreLayoutSidebarVisibility(false);
    }
  }

  render() {
    // Check URL params synchronously for first render
    const urlParams = new URLSearchParams(window.location.search);
    const shouldHideHeader = urlParams.get('hideHeader') === 'true';
    const shouldHideSidebar = urlParams.get('hideSidebar') === 'true';
    const { children, history } = this.props;

    let currentRoute = children.props.children.find(function (item) {
      let routeSpec = item.props.path;
      const routeActual = history.location.pathname;

      if (!routeSpec || !routeActual)
        return false;

      // Handle React Router v7 wildcard paths (e.g., "/maintenance/*")
      if (routeSpec.endsWith("/*")) {
        routeSpec = routeSpec.slice(0, -2);
      }

      const specParts = routeSpec.split("/");
      const actualParts = routeActual.split("/");

      // For routes with wildcards, only check the base path segments
      if (specParts.length > actualParts.length)
        return false;

      for (let i = 0; i < specParts.length; i++) {
        const spec = specParts[i];
        const actual = actualParts[i];

        if (spec[0] === ":")
          continue;

        if (spec !== actual)
          return false;
      }
      return true;
    });

    const { headerVisible, sidebarVisible } = this.props;
    
    // Use URL params to override Redux state for first render (before componentDidMount runs)
    const effectiveHeaderVisible = shouldHideHeader ? false : headerVisible;
    const effectiveSidebarVisible = shouldHideSidebar ? false : sidebarVisible;

    let bodyClassName = `app-body${effectiveHeaderVisible ? "" : " header-hidden"}`;
    if (currentRoute && currentRoute.props.rootCssClass) {
      bodyClassName += ` ${currentRoute.props.rootCssClass}`;
    }

    return (
        <Box sx={{ display: 'flex', '& > .app': { flexGrow: 1, overflow: 'hidden' } }}>
          {effectiveSidebarVisible && <MSidebar/>}
          <div className="app">
              {(currentRoute && effectiveHeaderVisible) &&
                <div className="app-header">
                  <div className="top-menu-bar md-grid">
                    <div className="header-child">
                      {" "}
                      {(this.props.headerDefinitions &&
                        this.props.headerDefinitions.topMenuTitle) ||
                        currentRoute.props.topMenuTitle}{" "}
                    </div>
                    <Header
                      history={this.props.history}
                      pathname={this.props.location.pathname}
                      pathkey={currentRoute.key}
                    />
                  </div>
                </div>
              }
              <section className={`app-body${effectiveHeaderVisible ? "" : " header-hidden"}`}>
                <div className={bodyClassName}>
                    {this.props.children}
                  </div>
                <ExpiredPasswordModal/>
              </section>
              <Footer />
            </div>
          </Box>
    );
  }
}

CoreLayout.propTypes = {
  children: PropTypes.element,
  getSidebar: PropTypes.func.isRequired,
  allCardsExpanded: PropTypes.func.isRequired,
  sidebar: PropTypes.object.isRequired,
  assignmentTool: PropTypes.object.isRequired,
  toggleMenuItem: PropTypes.func.isRequired,
  toggleCaseMenuItem: PropTypes.func.isRequired,
  getSearchResults: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  location: PropTypes.object,
  history: PropTypes.object,
  cardsExpanded: PropTypes.bool,
  resizeRequired: PropTypes.func.isRequired,
  getInternetUserList: PropTypes.func.isRequired,
  getFieldRepList: PropTypes.func.isRequired,
  getAppraiserList: PropTypes.func.isRequired,
  profile: PropTypes.object,

  sidebarExpand: PropTypes.func.isRequired,
  sidebarContract: PropTypes.func.isRequired,

  files: PropTypes.object.isRequired,
  fetchingFiles: PropTypes.bool.isRequired,
  formStatusChange: PropTypes.func.isRequired,
  headerDefinitions: PropTypes.object.isRequired,
  getNewSearchResults: PropTypes.func.isRequired,
  headerVisible: PropTypes.bool,
  sidebarVisible: PropTypes.bool,
  setCoreLayoutHeaderVisibility: PropTypes.func,
  setCoreLayoutSidebarVisibility: PropTypes.func,
};

const mstp = state => ({
  headerVisible: state.layout.coreLayoutSettings.headerVisible,
  sidebarVisible: state.layout.coreLayoutSettings.sidebarVisible,
});

const mdtp = dispatch => ({
  setCoreLayoutHeaderVisibility(params) {
    dispatch(setCoreLayoutHeaderVisibility(params));
  },
  setCoreLayoutSidebarVisibility(params) {
    dispatch(setCoreLayoutSidebarVisibility(params));
  }
});

export default connect(mstp, mdtp)(withRouter(CoreLayout));
